<div class="loading" *ngIf="loading">
  Cargando...
  <mdb-progress-bar class="progress primary-color-dark" mode="indeterminate"></mdb-progress-bar>
</div>
<div class="login d-flex justify-content-center full-height"
  [ngStyle]="{ 'background-image': 'url(./assets/img/fondo-login.png)' }">
  <div class="card-login">
    <!--Card-->
    <mdb-card cascade="true" narrower="true">
      <div class="view view-cascade gradient-card-header red-grandient align-items-center">
        <h5 class="card-header-title m-1">Iniciar sesión</h5>
      </div>

      <mdb-card-body cascade="true" class="text-center">
        <!--Card content-->
        <!-- Formulario -->
        <form action="" [formGroup]="formulario" (ngSubmit)="onSubmit()" class="text-center" style="color: #757575"
          novalidate>
          <div class="row">
            <div class="col">
              <!-- Empresa -->
              <div class="md-form">
                <mdb-select formControlName="rut_empresa" label="Empresa" [options]="optionsEmpresa"
                  placeholder="Seleccione Empresa" [filterEnabled]="true"></mdb-select>
                <div *ngIf="
                              formulario.get('rut_empresa').invalid &&
                              (formulario.get('rut_empresa').dirty ||
                                formulario.get('rut_empresa').touched)
                            ">
                  <mdb-error *ngIf="formulario.get('rut_empresa').hasError('required')">Por favor seleccione
                    Empresa</mdb-error>
                </div>
              </div>
            </div>
            <div class="col">
              <!-- Sucursal -->
              <div class="md-form">
                <mdb-select formControlName="codigo_sucursal" label="Sucursal" [options]="optionsSucursal"
                  placeholder="Seleccione Sucursal" [filterEnabled]="true"></mdb-select>
                <div *ngIf="
                              formulario.get('codigo_sucursal').invalid &&
                              (formulario.get('codigo_sucursal').dirty ||
                                formulario.get('codigo_sucursal').touched)
                            ">
                  <mdb-error *ngIf="formulario.get('codigo_sucursal').hasError('required')">Por favor seleccione
                    Sucursal</mdb-error>
                </div>
              </div>
            </div>
          </div>



          <!-- Rut_Usuario -->
          <div class="md-form">
            <mdb-icon fas icon="user" class="prefix grey-text"></mdb-icon>
            <input type="text" id="rut_usuario" class="form-control" #rut_usuario formControlName="rut_usuario" value=""
              maxLength="13" (blur)="mascaraRut($event)" />
            <label for="rut_usuario">RUT</label>
            <div class="error-container"
              *ngIf="formulario.get('rut_usuario').invalid && (formulario.get('rut_usuario').dirty || formulario.get('rut_usuario').touched)">
              <mdb-error *ngIf="formulario.get('rut_usuario').hasError('ValidaFormatoRut')">Por favor ingrese un RUT
                Valido</mdb-error>
            </div>
          </div>

          <!-- Passowrd -->
          <div class="md-form">
            <mdb-icon fas icon="key" class="prefix grey-text"></mdb-icon>
            <input value="" type="password" id="password" class="form-control" #password formControlName="password" />
            <label for="password">Contraseña</label>
            <div class="error-container" *ngIf="
                formulario.get('password').invalid &&
                (formulario.get('password').dirty ||
                  formulario.get('password').touched)
              ">
              <mdb-error *ngIf="formulario.get('password').hasError('required')">Por favor ingrese
                Contraseña</mdb-error>
            </div>
          </div>

          <div class="d-flex">
            <div>
              <!-- Remember me -->
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="materialLoginFormRemember" />
                <label class="form-check-label" for="materialLoginFormRemember">Recuérdame</label>
              </div>
            </div>
          </div>
          <br />
          <button mdbBtn color="secondary" class="mb-2" mdbWavesEffect block="true" type="submit"
            [disabled]="formulario.invalid || loadingLogin">
            <mdb-icon fas icon="spinner" spin="true" *ngIf="loadingLogin"></mdb-icon>
            Iniciar Sesión
          </button>
        </form>
      </mdb-card-body>
      <!--/.Card content-->
    </mdb-card>
    <br />
    <!--/.Card-->
    <div class="text-login">
      <img src="assets/img/Logo-Isstec_blanco.png" alt="LOGO" />
      <p>Isstec.cl</p>
      <p>¿ Necesitas Ayuda ?</p>
      <p>Contacta con nosotros:</p>
      <p>
        <mdb-icon fas icon="phone" style="margin-right: 10px"></mdb-icon>
        <mdb-icon fas icon="envelope"></mdb-icon>
      </p>
    </div>
  </div>
</div>